import React from "react";

const MoveTopButton = () => {
    return (
        <div style={{textAlign: 'right', display: 'flex', float: 'right'}}>
            <div onClick={() => window.scrollTo(0,0)} style={{padding: '10px 15px 10px 10px', cursor: 'pointer', color: 'red', borderRadius: 45, marginBottom: 40, width: 50, height: 50, fontSize: 20, boxShadow: '3px 4px 3px #ededed'}} data-testid="move-top-button">
                <i className="fa-solid fa-chevron-up"></i>
            </div>
        </div>
    );
};

export default MoveTopButton;
